import { render, staticRenderFns } from "./CommunityAppStoreApp.vue?vue&type=template&id=61e7122b&scoped=true&"
import script from "./CommunityAppStoreApp.vue?vue&type=script&lang=js&"
export * from "./CommunityAppStoreApp.vue?vue&type=script&lang=js&"
import style0 from "./CommunityAppStoreApp.vue?vue&type=style&index=0&id=61e7122b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e7122b",
  null
  
)

export default component.exports